import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries';
import { GlobalContext } from '../../../App';
import { updateOrAddItem, useAddData, useGetDataByName, useUpdateData } from '../../dataLocal/indexedDBHooks';
import { DataContext } from '../../../new_version/pages/pagesMains/GravesManagers/Graves';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const useCustomerQueries = () => {
  const { setDataCustomers, userId, db } = useContext(GlobalContext);
  const context = useContext(DataContext);
  const { AllDataEntities, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries();

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataCustomers = async () => {
    try {
      let query = `api/customers/getCustomers`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataCustomers';

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataCustomers(data?.resData || []);
      if (db) {
        getDataByName(nameEntity) 
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 7, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 7, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error);
    }
  };

  const addOrUpdateDataCustomer = async (data, unicId) => {
    let create = `api/customers/addCustomer`;
    let update = `api/customers/updateCustomer`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.id ? update : create}`;

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'customers',
      actionType: data?.unicId ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      };
    }

    try {
      let oldSpouse = context?.contextCustomers?.find(item => item?.spouse === data?.unicId)
      let newSpouse = context?.contextCustomers?.find(item => item?.unicId === data?.spouse)

      const serverResponse = await addOrUpdateDataEntity2(data, payload, url);
      console.log('Server Response:', serverResponse); // הדפסה של התגובה מהשרת

      if (serverResponse) {
        updateOrAddItem(db, 'myStore', data, 'dataCustomers', 7);

        // בדיקת בן הזוג הישן
        if (oldSpouse) {
          oldSpouse = { ...oldSpouse, spouse: null, maritalStatus: 1}; // עדכון בן הזוג הישן ל-null
          updateOrAddItem(db, 'myStore', oldSpouse, 'dataCustomers', 7);
        }

        // בדיקת בן הזוג החדש
        if (newSpouse) {
          newSpouse = { ...newSpouse, spouse: data.unicId, maritalStatus: 2}; // קישור בן הזוג החדש ללקוח הנוכחי
          updateOrAddItem(db, 'myStore', newSpouse, 'dataCustomers', 7);
        }

        return serverResponse; // החזרת התגובה המלאה למי שקרא לפונקציה
      } else {
        return false;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  const removeCustomer = (id) => {
    let query = `api/areaGraves/removeCustomer`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
    removeEntity(id, url);
  };

  return {
    AllDataCustomers,
    addOrUpdateDataCustomer,
    removeCustomer
  };
};

export default useCustomerQueries;
